module.exports = __webpack_public_path__ + "img/g4.84f98fbe.jpeg";